import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from "react-oidc-context";
import { cognitoAuthConfig } from './assets/services/Authentication.ts';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
     <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </StrictMode>,
)
